import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import BaseRoute from './base-route.gjs';
import Component from '@glimmer/component';
import ContactListItem from '../contact-list-item.gjs';
import GhostButton from 'ember-simplepractice/components/spds/action/button/ghost';
import SpdsFeedbackAlertBannerMessage from 'ember-simplepractice/components/spds/feedback/alert-banner/message';
import styles from './group-conversation-information.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class MessagingRoutesGroupConversationInformation extends Component {
  @service messagingNavigation;

  get routeHandler() {
    return this.args.handler;
  }

  get members() {
    return this.routeHandler?.members ?? [];
  }

  get memberContacts() {
    return this.members.map(member => ({
      id: member.id,
      members: [member],
      isDisabled: member.isDisabled,
    }));
  }

  goBack = () => {
    this.messagingNavigation.leaveChildRoute();
  };

  <template>
    <BaseRoute
      class="{{styles.component}} group-conversation-information-page"
      data-test-group-conversation-information-route
    >
      <:header>
        <GhostButton
          @fitContent={{true}}
          @iconOnly={{true}}
          {{on "click" this.goBack}}
          class="back-button"
          data-test-group-conversation-information-page-back-button
        >
          {{svgJar "messaging-chevron-left"}}
        </GhostButton>

        <span class="title">{{t "emc.group_conversation_information.title"}}</span>
      </:header>
      <:default>
        <div class="alert-container">
          <SpdsFeedbackAlertBannerMessage
            @type="info"
            @body={{t "emc.group_conversation_information.members_note"}}
            @isPermanent={{true}}
            @global={{true}}
            data-test-members-notice
          />
        </div>

        <h2 class="members-section-title" data-test-members-section-title>
          {{t "emc.group_conversation_information.members_section" count=this.members.length}}
        </h2>

        <ul class="members-list" data-test-members-list role="list">
          {{#each this.memberContacts as |memberContact|}}
            <ContactListItem @contact={{memberContact}} />
          {{/each}}
        </ul>
      </:default>
    </BaseRoute>
  </template>
}
